export const Types = {
  LOGIN: 'LOGIN',
  SAVE_LOGIN: 'SAVE_LOGIN',
  SAVE_INFO_USER: 'SAVE_INFO_USER',
  UPDATE_PROFILE_USER: 'UPDATE_PROFILE_USER',
}
